import React from 'react';
import { styled } from '@abyss/web/tools/styled';
import { Button } from 'src/common/Button';
import { Heading } from '@abyss/web/ui/Heading';
import { Layout } from '@abyss/web/ui/Layout';
import { config } from '@abyss/ui/tools/config';
import { useUserInfoStore } from 'src/store/useUserInfoStore';
import { useAdminContext } from 'src/hooks/useAdminContext';

const TinEntryPageButton = styled.div({
  margin: '20px 100px 20px 0',
  float: 'right',
});

const StyledHeading = styled(Heading, {
  fontWeight: 'bold',
});

export const OnboardProUser = () => {
  const [, setAdminContext] = useAdminContext({
    onCompleted: () => {
      window.location.replace(config('OBP_URL'));
    },
  });
  const { data: userInfo } = useUserInfoStore();

  const handleContinue = () => {
    setAdminContext({
      variables: {
        role: 'obp-user',
        id: userInfo?.uuid || '',
        username: userInfo?.username || '',
      },
    });
  };

  return (
    <React.Fragment>
      <Layout.Stack alignItems="left">
        <StyledHeading>Onboard Pro User</StyledHeading>
        <p data-testid="onboard-pro-user-header">
          The ID you signed in with has Onboard Pro User Access. Please enter
          the provider information using the button below.
        </p>
        <TinEntryPageButton>
          <Button data-testid="tin-entry-page-button" onClick={handleContinue}>
            TIN entry page
          </Button>
        </TinEntryPageButton>
      </Layout.Stack>
    </React.Fragment>
  );
};
